import { render, staticRenderFns } from "./remove_pending.vue?vue&type=template&id=d9a4af7a&scoped=true&"
import script from "./remove_pending.vue?vue&type=script&lang=js&"
export * from "./remove_pending.vue?vue&type=script&lang=js&"
import style0 from "./remove_pending.vue?vue&type=style&index=0&id=d9a4af7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a4af7a",
  null
  
)

export default component.exports